<template>
    <div class="row">
        <div class="col-12">
            <form class="form-inline">
                <div class="form-group">
                    <label class="col-form-label" for="bedrijf">Bedrijf&nbsp;&nbsp;&nbsp;</label>
                    <select @change="retrieveData" type="text" class="form-control" name="bedrijf" id="bedrijf" v-model="currentFilter.bedrijf">>
                        <template v-for="bedrijf in bedrijven">
                            <option :value="bedrijf.id" :selected="bedrijf.id == currentFilter.bedrijf">{{bedrijf.naam}}</option>
                        </template>
                    </select>
                </div>
                <div class="form-group">
                    &nbsp;&nbsp;&nbsp;<label class="col-form-label" for="naam">Naam&nbsp;&nbsp;&nbsp;</label>
                    <input @keyup="retrieveData" type="text" class="form-control" autocomplete="off" v-model="currentFilter.zoekstring" id="naam" name="naam" />
                </div>
            </form>
        </div><!--/.col-->
    </div><!--/.row-->
</template>

<script>
    export default {
        name: 'FilterForm',
        props: ['bedrijven', 'currentFilter', 'get-items'],

        methods: {
            retrieveData () {
                this.$emit('get-items', false);
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/pages/afdeling/FilterForm.vue